/** Human-readable labels for data source purpose values. */
export const PURPOSE_LABELS: Record<string, string> = {
  bom: 'BOM',
  ipc: 'IPC',
  supplier_data: 'Supplier Data',
  imds: 'IMDS',
  coc: 'CoC',
  activity: 'Activity',
  transactions: 'Transactions',
  process: 'Process',
  master_data: 'Master Data'
};

/** Human-readable labels for refresh frequency values. */
export const FREQUENCY_LABELS: Record<string, string> = {
  daily: 'Daily',
  weekly: 'Weekly',
  biweekly: 'Biweekly',
  monthly: 'Monthly',
  quarterly: 'Quarterly'
};

/** Human-readable labels for connector type values. */
export const CONNECTOR_LABELS: Record<string, string> = {
  s3: 'Amazon S3',
  azure_blob: 'Azure Blob',
  sftp: 'SFTP',
  sharepoint: 'SharePoint'
};

/** Section name used to identify the Data Sources tab in team settings. */
export const DATA_SOURCES_SECTION_NAME = 'Data Sources';
